import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'src/store';

export const searchSelect = (state: RootState) => state.global.search;

export const selectSearchKeyword = createSelector(
    searchSelect,
    (search) => search.keywords
);
